export const DISTRICT_MAP = {
  堅尼地城: '中西區',
  西環: '中西區',
  西營盤: '中西區',
  上環: '中西區',
  中環: '中西區',
  半山: '中西區',
  山頂: '中西區',
  金鐘: '中西區',
  灣仔: '灣仔區',
  銅鑼灣: '灣仔區',
  跑馬地: '灣仔區',
  渣甸山: '灣仔區',
  大坑: '灣仔區',
  天后: '灣仔區',
  寶馬山: '東區',
  樹仁大學: '東區',
  炮台山: '東區',
  北角: '東區',
  鰂魚涌: '東區',
  太古: '東區',
  西灣河: '東區',
  筲箕灣: '東區',
  柴灣: '東區',
  小西灣: '東區',
  摩星嶺: '南區',
  薄扶林: '南區',
  港大: '南區',
  數碼港: '南區',
  香港仔: '南區',
  鴨脷洲: '南區',
  黃竹坑: '南區',
  海洋公園: '南區',
  陽明山莊: '南區',
  深水灣: '南區',
  淺水灣: '南區',
  舂坎角: '南區',
  赤柱: '南區',
  大潭: '南區',
  石澳: '南區',
  馬灣: '荃灣區',
  迪士尼: '離島區',
  愉景灣: '離島區',
  東涌: '離島區',
  機場: '離島區',
  博覽館: '離島區',
  青衣: '葵青區',
  汀九: '荃灣區',
  深井: '荃灣區',
  小欖: '屯門區',
  屯門: '屯門區',
  嶺南大學: '屯門區',
  龍鼓灘: '屯門區',
  藍地: '屯門區',
  洪水橋: '元朗區',
  流浮山: '元朗區',
  天水圍: '元朗區',
  元朗: '元朗區',
  大欖: '屯門區',
  大棠: '元朗區',
  錦田: '元朗區',
  石崗: '元朗區',
  錦繡: '元朗區',
  加洲花園: '元朗區',
  落馬洲: '元朗區',
  沙頭角: '北區',
  軍地: '北區',
  古洞: '北區',
  上水: '北區',
  粉嶺: '北區',
  坪輋: '北區',
  太和: '大埔區',
  康樂園: '大埔區',
  三門仔: '大埔區',
  大尾篤: '大埔區',
  教育學院: '大埔區',
  大埔: '大埔區',
  中文大學: '大埔區',
  馬料水: '大埔區',
  九肚山: '沙田區',
  火炭: '沙田區',
  金山: '沙田區',
  沙田: '沙田區',
  大圍: '沙田區',
  馬鞍山: '沙田區',
  西貢: '西貢區',
  井欗樹: '西貢區',
  蠔涌: '西貢區',
  大網仔: '西貢區',
  十四鄉: '西貢區',
  科技大學: '西貢區',
  銀線灣: '西貢區',
  大坳門: '西貢區',
  布袋澳: '西貢區',
  馬游塘: '觀塘區',
  將軍澳: '西貢區',
  將軍澳工業邨: '西貢區',
  日出康城: '西貢區',
  葵涌: '葵青區',
  梨木樹: '葵青區',
  華景山莊: '葵青區',
  荃灣: '荃灣區',
  大帽山: '荃灣區',
  荔景: '葵青區',
  美孚: '深水埗區',
  荔枝角: '深水埗區',
  長沙灣: '深水埗區',
  深水埗: '深水埗區',
  南昌: '深水埗區',
  大角咀: '深水埗區',
  奧運: '深水埗區',
  昂船洲: '深水埗區',
  石硤尾: '深水埗區',
  太子: '油尖旺區',
  旺角: '油尖旺區',
  油麻地: '油尖旺區',
  佐敦: '油尖旺區',
  尖沙咀: '油尖旺區',
  何文田: '九龍城區',
  九龍塘: '九龍城區',
  城市大學: '九龍城區',
  浸會大學: '九龍城區',
  畢架山: '九龍城區',
  大老山: '九龍城區',
  觀音山: '九龍城區',
  紅磡: '九龍城區',
  理工大學: '九龍城區',
  土瓜灣: '九龍城區',
  九龍城: '九龍城區',
  樂富: '黃大仙區',
  橫頭磡: '黃大仙區',
  啟德: '黃大仙區',
  慈雲山: '黃大仙區',
  黃大仙: '黃大仙區',
  新蒲崗: '黃大仙區',
  鑽石山: '黃大仙區',
  彩虹: '黃大仙區',
  飛鵝山: '黃大仙區',
  順利村: '觀塘區',
  秀茂坪: '觀塘區',
  九龍灣: '觀塘區',
  牛頭角: '觀塘區',
  觀塘: '觀塘區',
  藍田: '觀塘區',
  油塘: '觀塘區',
  文錦渡: '北區',
  新娘潭: '大埔區',
  鹿頸: '北區',
  和合石: '北區',
  司徒拔道: '灣仔區',
  歌連臣角: '東區',
  城門水塘: '荃灣區',
  郝德傑道: '深水埗區',
  將軍澳華人永遠墳場: '西貢區',
  和合石墳場: '北區',
}



// WEBPACK FOOTER //
// ./src/constants/delivery.js